export const locale = {
    lang: 'en',
    data: {
        TOAST_STACK: {
            CLEAR_ALL: 'Clear all'
        }
    }
};
